import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons"

export const MinusCircle = (props) => {
  return <FontAwesomeIcon faIcon={faMinusCircle} {...props} />
}
